
import {
  defineComponent, onMounted, ref, watch,
} from 'vue';
import {
  DatePicker, ConfigProvider, message, Select,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment, { Moment, } from 'moment';

import { post, } from '@/request/request';

export default defineComponent({
  components: {
    DatePicker,
    ConfigProvider,
    Select,
  },
  emits: ['searchData', 'typeChange',],
  setup (props, { emit, }) {
    // 污染物类型
    const polutionButton = {
      aqi: '<span>AQI</span>',
      pm25: '<span>PM<sub>2.5</sub></span>',
      pm10: '<span>PM<sub>10</sub></span>',
      so2: '<span>SO<sub>2</sub></span>',
      no2: '<span>NO<sub>2</sub></span>',
      o3: '<span>O<sub>3</sub></span>',
      co: '<span>CO</span>',
    };
    const startTime = ref<Moment>(moment(moment().startOf('month').format('YYYYMMDD00'), 'YYYYMMDDHH'));
    const oldStartTime = ref<Moment>(moment(moment().subtract(1, 'days').format('YYYYMMDD00'), 'YYYYMMDDHH'));
    const endTime = ref<Moment>(moment(moment().subtract(1, 'days').format('YYYYMMDD23'), 'YYYYMMDDHH'));
    const oldEndTime = ref<Moment>(moment(moment().subtract(1, 'days').format('YYYYMMDD23'), 'YYYYMMDDHH'));
    const selectedStation = ref<any>('');
    const selectedStationType = ref<any>('');
    // const options = ref<SelectProps['options']>([]);
    const options = ref<any>([]);
    const selectElement = ref<any>('pm25');

    // 日期选择框禁用日期（历史3个月至当前）
    const disabledEndDate = (endValue: string | any): boolean => endValue.valueOf() <= moment().add(1,'days').subtract(100, 'days').valueOf() ||
      endValue.valueOf() >= moment().add(1, 'days').valueOf();

    // 日期选择框禁用日期（历史3个月至当前）
    const disabledStartDate = (endValue: string | any): boolean => endValue.valueOf() <= moment().subtract(100, 'days').valueOf() ||
      endValue.valueOf() >= moment().valueOf();

    const stationChange = (value: string,option: any) => {
      selectedStationType.value = option.data;
    };

    // 是否点击确定按钮
    const startOkFlag = ref(false);
    const endOkFlag = ref(false);

    /**
     * 日期选择框变化触发
     * @param {any} date 时间
     * @param {any} dateString 时间
     * @returns {void}
     */
    const search = () => {
      const startStr = moment(startTime.value).format('YYYYMMDDHH');
      const endStr = moment(endTime.value).format('YYYYMMDDHH');

      const params = {
        selectedStation: selectedStation.value,
        selectedStationType: selectedStationType.value,
        startStr,
        endStr,
      };

      emit('searchData', params);
    };

    watch(() => startTime.value, (cur, old) => {
      const isAfter = cur.isAfter(endTime.value);

      if (isAfter) {
        message.error('开始时间不能大于结束时间');
        startTime.value = old;
      }
    });

    /**
     * 开始时间点击确定
     * @param {Moment} date 选中日期时间
     * @returns {void}
     */
    const startChange = (date: Moment) => {
      startOkFlag.value = true;
    };

    const openStartChange = (status: any) => {
      if (status) {
        oldStartTime.value = startTime.value;
      } else if (!startOkFlag.value) {
        startTime.value = oldStartTime.value;
      }

      startOkFlag.value = false;
    };

    const openEndChange = (status: any) => {
      if (status) {
        oldEndTime.value = endTime.value;
      } else if (!endOkFlag.value) {
        endTime.value = oldEndTime.value;
      }

      endOkFlag.value = false;
    };

    watch(() => endTime.value, (cur, old) => {
      const isAfter = startTime.value.isAfter(cur);

      if (isAfter) {
        message.error('结束时间不能小于开始时间');
        endTime.value = old;
      }
    });

    /**
     * 结束时间点击确定
     * @param {Moment} date 选中日期时间
     * @returns {void}
     */
    const endChange = (date: Moment) => {
      endOkFlag.value = true;
    };

    const clickPollution = (val: string) => {
      selectElement.value = val;
      emit('typeChange', val);
    };

    /**
     * 处理数据
     * @method dealStation
     * @param {any} value 数据对象
     * @returns {any[]}数组
     */
    const dealStation = (value: any): any[] => {
      const temp: any = {
        1: {
          label: '省控站',
          options: [],
        },
        2: {
          label: '市控站',
          options: [],
        },
        3: {
          label: '小微站',
          options: [],
        },
        4: {
          label: '国控站',
          options: [],
        },
      };

      value.forEach((item: any) => {
        temp[Number(item.type)].options.push({
          value: item.name,
          label: item.name,
          data: item.type,
        });
      });

      return Object.values(temp);
    };

    /**
     * 获取站点数据
     * @return {void}
     */
    const loadStationsData = () => {
      post(`/analyze/selectAllStation`, { type: '1', })
        .then((data: any) => {
          // 获取站点数据之后，进行气象数据的初始化请求
          selectedStation.value = data[0].name;
          selectedStationType.value = data[0].type;
          options.value = dealStation(data);
          search();
        })
        .catch((msg: any) => {
          message.error(msg);
        });
    };

    onMounted(() => {
      loadStationsData();
    });

    return {
      zhCN,
      polutionButton,
      startTime,
      endTime,
      selectedStation,
      selectedStationType,
      options,
      selectElement,
      startChange,
      openStartChange,
      openEndChange,
      endChange,
      disabledStartDate,
      disabledEndDate,
      search,
      stationChange,
      clickPollution,
    };
  },
});
